import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating a view
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing a view for the tablesquare Day Report 2.
 * @extends JetView
 */
export default class tablesquareDayReport2View extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define a date formatting function based on the application's configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Preserve the context of 'this' for use within nested functions
        var vthis = this;

        // Extend the default Webix data filter to create a custom summary column filter
        webix.ui.datafilter.mySummColumn = webix.extend(
            {
                /**
                 * Refreshes the summary column with the calculated result.
                 * @param {Object} master - The master view containing the data.
                 * @param {HTMLElement} node - The DOM node representing the summary cell.
                 * @param {Object} value - The value object containing column information.
                 */
                refresh: function(master, node, value) {
                    var result = 0; // Initialize the result accumulator
                    var resultFormat = 0; // Variable to hold the formatted result
                    var size = $$('datatable').getPager().config.size; // Get the current page size
                    var page = $$('datatable').getPage(); // Get the current page number
                    var first = size * page; // Calculate the index of the first item on the current page
                    var last = first + size - 1; // Calculate the index of the last item on the current page
                    var count = 0; // Initialize a counter for iterating through data

                    // Iterate through each data object in the master view
                    master.data.each(function(obj) {
                        // Check if the current index is within the bounds of the current page
                        if (count >= first && count <= last) {
                            // Accumulate the sum of the specified column's values
                            result += parseFloat(obj[value.columnId]);
                        }
                        count++; // Increment the counter
                    });

                    // Format the result using the price format defined in Webix internationalization
                    resultFormat = webix.i18n.priceFormat(result);
                    // Update the inner HTML of the summary cell with the formatted result
                    node.firstChild.innerHTML = resultFormat;
                },
            },
            // Inherit properties and methods from the existing summary column filter
            webix.ui.datafilter.summColumn,
        );
        return {
            // Main structure containing rows for the UI component
            rows: [
                {
                    // Row configuration for the preloader
                    id: 'preloader',
                    cols: [
                        {
                            // DataTable configuration
                            view: 'datatable',
                            css: 'webix_header_border webix_data_border webix_footer_border',
                            id: 'datatable',
                            select: true, // Enables row selection
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling based on screen width
                            columns: [
                                {
                                    // Column for action buttons
                                    id: 'ActionTittle',
                                    header: '',
                                    width: 100,
                                    height: 25,
                                    tooltip: 'Acción', // Tooltip for the column
                                    template: function(obj) {
                                        // Template for action icons
                                        return '<span placeholder=\'Aprobar\' class=\'webix_icon wxi-close printer\'></span><span placeholder=\'files\' class=\'webix_icon icon-file-text1 files\'></span><span placeholder=\'files\' class=\'webix_icon icon-file-text1 files2\'></span><span placeholder=\'files\' class=\'webix_icon icon-file-text1 files4\'></span>';
                                    },
                                    footer: 'Total:', // Footer text for the column
                                },
                                {
                                    // Column for editing/closing box action
                                    id: 'EditCloseBox',
                                    header: '',
                                    width: 70,
                                    height: 25,
                                    tooltip: 'Acción',
                                    hidden: !devConfig.getPermAction('editCloseBox', 'Edit'), // Conditional visibility based on permissions
                                    css: 'prm-editCloseBox',
                                    template: function(obj) {
                                        // Template for edit icon
                                        return '<span placeholder=\'Editar\' class=\'webix_icon wxi-close edit\'></span>';
                                    },
                                },
                                {
                                    // Column for User ID
                                    id: 'User',
                                    header: _('ID Usuario'), // Localized header
                                    width: 100,
                                },
                                {
                                    // Column for User Name
                                    id: 'UserName',
                                    header: _('Usuario'), // Localized header
                                    width: 150,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    // Column for Date
                                    id: 'Date',
                                    header: _('Fecha'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    // Column for Initial Amount
                                    id: 'AmountBegin',
                                    header: _('Dinero Inicial'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    footer: { content: 'mySummColumn' }, // Custom footer content
                                },
                                {
                                    // Column for Proper Incomes
                                    id: 'ProperIncomes',
                                    header: _('Ingresos Propios'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    footer: { content: 'mySummColumn' }, // Custom footer content
                                },
                                {
                                    // Column for Credit Card Incomes
                                    id: 'IncomesCreditCards',
                                    header: _('Ingresos Pot Tarjetas de Credito'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    footer: { content: 'mySummColumn' }, // Custom footer content
                                },
                                {
                                    // Column for Proper Expenses
                                    id: 'ProperExpenses',
                                    header: _('Egresos Propios'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    footer: { content: 'mySummColumn' }, // Custom footer content
                                },
                                {
                                    // Column for Product Incomes
                                    id: 'ProductsIncomes',
                                    header: _('Ingresos Productos'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    footer: { content: 'mySummColumn' }, // Custom footer content
                                },
                                {
                                    // Column for Product Expenses
                                    id: 'ProductsExpenses',
                                    header: _('Egresos Productos'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    footer: { content: 'mySummColumn' }, // Custom footer content
                                },
                                {
                                    // Column for Other Incomes
                                    id: 'OthersIncomes',
                                    header: _('Otros Ingresos'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    footer: { content: 'mySummColumn' }, // Custom footer content
                                },
                                {
                                    // Column for Other Expenses
                                    id: 'OthersExpenses',
                                    header: _('Otros Egresos'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    footer: { content: 'mySummColumn' }, // Custom footer content
                                },
                                {
                                    // Column for Final Amount
                                    id: 'Total',
                                    header: _('Dinero Final'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    footer: { content: 'mySummColumn' }, // Custom footer content
                                },
                            ],
                            footer: true, // Enables footer for the datatable
                            math: true, // Enables mathematical operations for footer
                            loadahead: 0, // Number of rows to load ahead
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID for pagination
                            onClick: {
                                // Event handlers for click actions on icons
                                printer: function(euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    var vvthis = this; // Reference to the current context
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type for the request
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'Accounting/GetDetailsSquareDayPDF',
                                            '{"Id":"' + item.Id + '"}', // Send item ID in the request body
                                            {
                                                error: function(text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Display error message
                                                },
                                                success: function(text, data, XmlHttpRequest) {
                                                    data = JSON.parse(text); // Parse the response data
                                                    if (!data.HasError) {
                                                        // Check for errors in the response
                                                    }
                                                    webix
                                                        .ui({
                                                            // Create a modal window to display the PDF
                                                            view: 'window',
                                                            width: 500,
                                                            height: 700,
                                                            head: {
                                                                view: 'toolbar',
                                                                cols: [
                                                                    {
                                                                        view: 'label',
                                                                        label: _('Factura'), // Localized label
                                                                    },
                                                                    {
                                                                        view: 'button',
                                                                        label: 'X', // Close button label
                                                                        width: 100,
                                                                        align: 'right',
                                                                        click: '$(\'windowfact2\').close();', // Close window action
                                                                    },
                                                                ],
                                                            },
                                                            id: 'windowfact2', // Window ID
                                                            modal: true, // Modal window
                                                            position: 'center', // Center position
                                                            body: {
                                                                rows: [
                                                                    {
                                                                        // Iframe to display the PDF
                                                                        template:
                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>',
                                                                    },
                                                                ],
                                                            },
                                                        })
                                                        .show(); // Show the modal window
                                                    var reader = new FileReader(); // Create a FileReader to read the PDF data
                                                    reader.onload = function(event) {
                                                        $$('pdf').clear(); // Clear previous PDF data
                                                        $$('pdf').parse({
                                                            data: event.target.result, // Parse the new PDF data
                                                        });
                                                    };

                                                    function b64toBlob(b64Data, contentType, sliceSize) {
                                                        // Convert base64 data to Blob
                                                        contentType = contentType || '';
                                                        sliceSize = sliceSize || 512;
                                                        var byteCharacters = atob(b64Data); // Decode base64 string
                                                        var byteArrays = [];
                                                        for (
                                                            var offset = 0;
                                                            offset < byteCharacters.length;
                                                            offset += sliceSize
                                                        ) {
                                                            var slice = byteCharacters.slice(
                                                                offset,
                                                                offset + sliceSize,
                                                            );
                                                            var byteNumbers = new Array(slice.length);
                                                            for (var i = 0; i < slice.length; i++) {
                                                                byteNumbers[i] = slice.charCodeAt(i); // Convert characters to byte numbers
                                                            }
                                                            var byteArray = new Uint8Array(byteNumbers); // Create a Uint8Array from byte numbers
                                                            byteArrays.push(byteArray); // Add to byte arrays
                                                        }
                                                        var blob = new Blob(byteArrays, {
                                                            type: contentType,
                                                        }); // Create a Blob from byte arrays
                                                        return blob; // Return the Blob
                                                    }

                                                    var contentType = 'application/pdf'; // Set content type for PDF
                                                    var b64Data = data.Pdf; // Get base64 PDF data from response
                                                    var blob = b64toBlob(b64Data, contentType); // Convert base64 to Blob
                                                    var file = window.URL.createObjectURL(blob); // Create a URL for the Blob
                                                    document.querySelector('iframe').src = file; // Set iframe source to the Blob URL
                                                    var printWindow = window.open(file, '', 'width=800,height=500'); // Open print window
                                                    printWindow.print(); // Trigger print dialog
                                                },
                                            },
                                        );
                                },
                                edit: function(euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    vthis.show('closeBoxEdit?CloseBoxId=' + item.Id); // Show edit dialog with item ID
                                },
                                files: function(euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    vthis.app.callEvent('customer:updateFinance2', [item.Id]); // Trigger event for updating finance
                                },
                                files2: function(euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    vthis.app.callEvent('customer2:updateFinance2', [item.Id]); // Trigger event for updating finance
                                },
                                files4: function(euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    vthis.app.callEvent('customer4:updateFinance2', [item.Id]); // Trigger event for updating finance
                                },
                            },
                        },
                    ],
                },
            ],
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service from the app and assign it to the variable '_'
        const _ = this.app.getService('locale')._;
        // Get the data table component from the UI and assign it to the variable 'grid'
        grid = $$('datatable');
        // Construct the API URL for fetching the square day report
        var url = devConfig.geturlApi() + 'Accounting/GetSquareDayReport2';
        // Initialize an empty filter variable
        var filter = '';
        // Get the current theme configuration from the app
        const theme = this.app.config.theme;
        // Initialize a flag variable to false
        var flag = false;
        // Create a popup window using Webix UI
        var popup = webix.ui({
            view: 'window', // Define the view type as a window
            width: 750, // Set the width of the window
            height: 500, // Set the height of the window
            id: 'detailSquareDay', // Assign an ID to the window
            scroll: true, // Enable scrolling within the window
            head: {
                // Define the header of the window
                view: 'toolbar', // Set the header view type as a toolbar
                cols: [
                    // Define the columns in the toolbar
                    { view: 'label', label: _('Cuadre de Día') }, // Add a label with localized text
                    {
                        view: 'icon', // Add an icon button
                        icon: 'wxi-close', // Set the icon to a close icon
                        click: function() {
                            // Define the click event for the icon
                            // Clear the HTML content of the templateResume component
                            $$('templateResume').setHTML('');
                            // Hide the top parent view of the icon button
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                // Define the body of the window
                margin: 20, // Set the margin around the body
                minWidth: 200, // Set the minimum width of the body
                cols: [
                    // Define the columns in the body
                    {
                        margin: 10, // Set the margin for the column
                        rows: [
                            // Define the rows in the column
                            {
                                view: 'template', // Set the view type as a template
                                id: 'templateResume', // Assign an ID to the template
                                // Define the HTML template content
                                template:
                                    '<div class=\'container-preload\' style=" position: absolute; left: 0px; top: 0px; background: #ffffffba; "><div style=\'position: fixed; top: calc(50% - 57px);left: calc(50% - 75px);width: 150px;\' class=\'progress\'><div class=\'icon-doradobet\'></div></div></div>',
                            },
                        ],
                    },
                ],
            },
        });

        /**
         * Attaches a double-click event to the grid to display detailed financial information.
         * @param {string} id - The ID of the clicked item.
         * @param {Event} e - The event object.
         * @param {HTMLElement} node - The HTML node of the clicked item.
         */
        grid.attachEvent('onItemDblClick', function(id, e, node) {
            var vthis = this; // Reference to the current grid instance
            var item = this.getItem(id); // Retrieves the clicked item's data
            popup.show(); // Displays the popup window
            webix.delay(
                function() {
                    // Triggers the 'customer:updateFinance' event with the item's ID after a delay
                    vthis.$scope.app.callEvent('customer:updateFinance', [item.Id]);
                },
                '',
                '',
                1000,
            );
        });

        /**
         * Listens for the 'customer:updateFinance' event to fetch and display financial details.
         * @param {string} id - The ID of the customer to fetch financial details for.
         */
        this.on(this.app, 'customer:updateFinance', (id) => {
            $$('templateResume').setHTML(''); // Clears the content of the templateResume element
            const test = this; // Reference to the current context
            webix.ajax().get(devConfig.geturlApi() + 'Accounting/GetDetailsSquareDay', 'id=' + id, {
                /**
                 * Handles errors during the AJAX request.
                 * @param {string} text - The error message.
                 * @param {Object} data - The response data.
                 * @param {XMLHttpRequest} XmlHttpRequest - The XMLHttpRequest object.
                 */
                error: function(text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Displays an error message
                },
                /**
                 * Handles the successful response of the AJAX request.
                 * @param {string} text - The response text.
                 * @param {Object} data - The response data.
                 * @param {XMLHttpRequest} XmlHttpRequest - The XMLHttpRequest object.
                 */
                success: function(text, data, XmlHttpRequest) {
                    text = JSON.parse(text); // Parses the response text as JSON
                    text = text.Data; // Extracts the data property
                    var totalincomes = 0; // Initializes the total incomes
                    var totalexpenses = 0; // Initializes the total expenses
                    var shtml =
                        '<div style="width: 100%;overflow: scroll !important;position: relative;display: inline-block;height: 100%;"> <h2> Detalle </h2> ';
                    shtml += '<div style=" width: 100%; "> <h2> Detalle </h2> ';
                    shtml +=
                        '<div style=" width: 100%; padding: 0px 0px;"> <div style="display: inline-block;width: 38%;font-weight: bold;">Dinero Inicial</div><div style="display: inline-block;text-align: right;width: 30%;"><div style="color: green;display: inline-block;">(+)</div>' +
                        webix.i18n.priceFormat(text.SquareDay[0].AmountBegin) +
                        ' </div><div style="text-align: right;display: inline-block;padding-left: 5px;padding-right: 3px;width: 30%;"> </div>  </div>';

                    // Iterates through tickets to calculate incomes and expenses
                    text.Tickets.forEach(function(obj) {
                        shtml +=
                            '<div style=" width: 100%; padding: 3px 0px;"> <div style="display: inline-block;width: 38%;font-weight: 100;">' +
                            obj.Description +
                            '</div><div style="display: inline-block;text-align: right;width: 30%;"><div style="color: green;display: inline-block;">(+)</div>' +
                            webix.i18n.priceFormat(obj.Amount) +
                            ' </div><div style="text-align: right;display: inline-block;padding-left: 5px;padding-right: 3px;width: 30%;"><div style="color: red;display: inline-block;">(-)</div>' +
                            webix.i18n.priceFormat(obj.AmountWin) +
                            ' </div>  </div>';
                        totalincomes += parseFloat(obj.Amount);
                        totalexpenses += parseFloat(obj.AmountWin);
                    });

                    // Iterates through deposits to calculate incomes
                    text.Deposit.forEach(function(obj) {
                        shtml +=
                            '<div style=" width: 100%; padding: 3px 0px;"> <div style="display: inline-block;width: 38%;font-weight: 100;">' +
                            obj.Description +
                            '</div><div style="display: inline-block;text-align: right;width: 30%;"><div style="color: green;display: inline-block;">(+)</div>' +
                            webix.i18n.priceFormat(obj.Amount) +
                            ' </div><div style="text-align: right;display: inline-block;padding-left: 5px;padding-right: 3px;width: 30%;">  </div>  </div>';
                        totalincomes += parseFloat(obj.Amount);
                    });

                    // Iterates through withdrawals to calculate expenses
                    text.Withdraw.forEach(function(obj) {
                        shtml +=
                            '<div style=" width: 100%; padding: 3px 0px;"> <div style="display: inline-block;width: 38%;font-weight: 100;">' +
                            obj.Description +
                            '</div><div style="display: inline-block;text-align: right;width: 30%;"></div><div style="text-align: right;display: inline-block;padding-left: 5px;padding-right: 3px;width: 30%;"><div style="color: red;display: inline-block;">(-)</div>' +
                            webix.i18n.priceFormat(obj.Amount) +
                            ' </div>  </div>';
                        totalexpenses += parseFloat(obj.Amount);
                    });
                    shtml +=
                        '<div style=" width: 100%; padding: 5px 0px;"> <div style="display: inline-block;width: 38%;font-weight: bold;">Productos</div><div style="display: inline-block;font-weight: bold;text-align: right;width: 30%;color:green;">Apuestas</div><div style="text-align: right;display: inline-block;padding-left: 5px;padding-right: 3px;font-weight: bold;width: 30%;color: red;">Premios</div>  </div>';
                    text.Products.forEach(function(obj) {
                        var cssCorrection = '';
                        if (obj.IsCorrection) {
                            cssCorrection = 'background: rgba(204, 204, 204, 0.4117647058823529);';
                        }
                        shtml +=
                            '<div style=" width: 100%; padding: 3px 0px;' +
                            cssCorrection +
                            '"> <div style="display: inline-block;width: 38%;font-weight: 100;">' +
                            obj.Description +
                            '</div><div style="display: inline-block;text-align: right;width: 30%;"><div style="color: green;display: inline-block;">(+)</div>' +
                            webix.i18n.priceFormat(obj.Amount) +
                            ' </div><div style="text-align: right;display: inline-block;padding-left: 5px;padding-right: 3px;width: 30%;"> <div style="color: red;display: inline-block;">(-)</div>' +
                            webix.i18n.priceFormat(obj.AmountWin) +
                            ' </div>  </div>';
                        totalincomes += parseFloat(obj.Amount);
                        totalexpenses += parseFloat(obj.AmountWin);
                    });
                    shtml +=
                        '<div style=" width: 100%; padding: 5px 0px;"> <div style="display: inline-block;width: 38%;font-weight: bold;"></div><div style="display: inline-block;font-weight: bold;text-align: right;width: 30%;color: green;">Ingresos</div><div style="text-align: right;display: inline-block;padding-left: 5px;padding-right: 3px;font-weight: bold;width: 30%;"></div>  </div>';
                    shtml +=
                        `<div style="width: 100%;">
                              <div style="display: inline-block;font-weight: bold;text-align: right;width: 50%;">
                                ` +
                        _('Documento') +
                        `<br>
                              </div>
                            </div>`;
                    text.Incomes.forEach(function(obj) {
                        var cssCorrection = '';
                        if (obj.IsCorrection) {
                            cssCorrection = 'background: rgba(204, 204, 204, 0.4117647058823529);';
                        }
                        shtml +=
                            `<div style=" width: 100%; padding: 3px 0px;` +
                            cssCorrection +
                            `">
                                    <div style="display: inline-block;width: 40%;font-weight: 100;">` +
                            obj.Description +
                            `</div>
                                    <div style="display: inline-block;width: 10%;font-weight: 100;">` +
                            obj.Reference +
                            `</div>
                                    <div style="display: inline-block;text-align: right;width: 20%;">
                                      <div style="color: green;display: inline-block;">
                                        (+)
                                      </div>
                                      ` +
                            webix.i18n.priceFormat(obj.Amount) +
                            `
                                    </div>
                                  </div>`;
                        totalincomes += parseFloat(obj.Amount);
                    });
                    shtml +=
                        '<div style=" width: 100%; padding: 5px 0px;"> <div style="display: inline-block;width: 38%;font-weight: bold;"></div><div style="display: inline-block;font-weight: bold;text-align: right;width: 30%;"></div><div style="text-align: right;display: inline-block;padding-left: 5px;padding-right: 3px;font-weight: bold;width: 30%;color: red;">Egresos</div> </div>';
                    shtml +=
                        `<div style="width: 100%;">
                                <div style="display: inline-block;font-weight: bold;text-align: right;width: 50%;">
                                  ` +
                        _('Tipo Documento') +
                        `
                                </div>
                                <div style="display: inline-block;font-weight: bold;text-align: right;width: 10%;">
                                  ` +
                        _('Serie') +
                        `
                                </div>
                                <div style="display: inline-block;font-weight: bold;text-align: right;width: 20%;">
                                  ` +
                        _('Documento') +
                        `
                                </div>
                              </div>`;
                    text.Expenses.forEach(function(obj) {
                        var cssCorrection = '';
                        if (obj.IsCorrection) {
                            cssCorrection = 'background: rgba(204, 204, 204, 0.4117647058823529);';
                        }
                        shtml +=
                            `<div style=" width: 100%; padding: 3px 0px;` +
                            cssCorrection +
                            `">
                                    <div style="display: inline-block;width: 40%;font-weight: 100;">` +
                            obj.Description +
                            `</div>
                                    <div style="display: inline-block;width: 20%;font-weight: 100;">` +
                            obj.NameDocument +
                            `</div>
                                    <div style="display: inline-block;width: 15%;font-weight: 100;">` +
                            obj.Serie +
                            `</div>
                                    <div style="display: inline-block;width: 10%;font-weight: 100;">` +
                            obj.Reference +
                            `</div>
                                    <div style="display: inline-block;width: 10%;font-weight: 100;">
                                        <div style="color: red;display: inline-block;">
                                          (-)
                                        </div>` +
                            webix.i18n.priceFormat(obj.Amount) +
                            `</div>
                                  </div>`;
                        totalexpenses += parseFloat(obj.Amount);
                    });
                    shtml +=
                        '<div style=" width: 100%; padding: 5px 0px;"> <div style="display: inline-block;width: 38%;font-weight: bold;"></div><div style="display: inline-block;font-weight: bold;text-align: right;width: 30%;"></div><div style="text-align: right;display: inline-block;padding-left: 5px;padding-right: 3px;font-weight: bold;width: 30%;">Ingresos Tarjetas de Credito</div> </div>';
                    text.IncomesCreditCards.forEach(function(obj) {
                        var cssCorrection = '';
                        if (obj.IsCorrection) {
                            cssCorrection = 'background: rgba(204, 204, 204, 0.4117647058823529);';
                        }
                        shtml +=
                            '<div style=" width: 100%; padding: 3px 0px;' +
                            cssCorrection +
                            '"> <div style="display: inline-block;width: 38%;font-weight: 100;">' +
                            obj.Description +
                            '</div><div style="display: inline-block;text-align: right;width: 30%;"> </div><div style="text-align: right;display: inline-block;padding-left: 5px;padding-right: 3px;width: 30%;"> <div style="color: red;display: inline-block;">(-)</div>' +
                            webix.i18n.priceFormat(obj.Amount) +
                            ' </div>  </div>';
                        totalexpenses += parseFloat(obj.Amount);
                    });
                    shtml +=
                        '<div style="width: 100%;padding: 0px 0px;border-top: 1px dotted;margin-top: 10px;"> <div style="display: inline-block;width: 38%;font-weight: bold;">Total</div><div style="display: inline-block;text-align: right;width: 30%;"><div style="color: green;display: inline-block;">(+)</div>' +
                        webix.i18n.priceFormat(totalincomes) +
                        ' </div><div style="text-align: right;display: inline-block;padding-left: 5px;padding-right: 3px;width: 30%;"> <div style="color: red;display: inline-block;">(-)</div>' +
                        webix.i18n.priceFormat(totalexpenses) +
                        ' </div>  </div>';
                    shtml +=
                        '<div style="width: 100%;padding: 0px 0px;border-top: 1px dotted;margin-top: 10px;"> <div style="display: inline-block;width: 38%;font-weight: bold;">Dinero en Caja: </div><div style="display: inline-block;text-align: right;width: 30%;"> </div><div style="text-align: right;display: inline-block;padding-left: 5px;padding-right: 3px;width: 30%;">' +
                        webix.i18n.priceFormat(text.Total) +
                        ' </div>  </div>';
                    $$('templateResume').setHTML(shtml);
                },
            });
        });

        // Listen for the 'customer:updateFinance2' event on the app instance
        this.on(this.app, 'customer:updateFinance2', (id) => {
            // Clear the HTML content of the 'templateResume' element
            $$('templateResume').setHTML('');
            const test = this; // Reference to the current context
            webix.ajax().get(
                // Fetch data from the API endpoint for accounting details
                devConfig.geturlApi() + 'Accounting/GetDetailsSquareDay',
                'id=' + id + '&FExport=1', // Query parameters for the request
                {
                    // Handle error response
                    error: function(text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Display error message
                    },
                    // Handle successful response
                    success: function(text, data, XmlHttpRequest) {
                        var textSp = JSON.parse(text); // Parse the JSON response
                        text = textSp.Data; // Extract the data from the parsed response
                        var totalincomes = 0; // Initialize total incomes
                        var totalexpenses = 0; // Initialize total expenses
                        var shtml = ''; // Initialize string for CSV output
                        // Set CSV header for sales data
                        shtml = 'Punto de Venta;Día;Cuenta Contable;Tickets - Pagos;Recargas;N. Retiros';
                        var accid = ''; // Variable to store account ID
                        var tickets = 0; // Initialize tickets variable
                        // Calculate total tickets and account ID from the Tickets array
                        text.Tickets.forEach(function(obj) {
                            tickets = parseFloat(obj.Amount) - parseFloat(obj.AmountWin); // Calculate net tickets
                            accid = obj.AccountProduct; // Store account ID
                        });
                        var deposits = 0; // Initialize deposits variable
                        // Calculate total deposits and account ID from the Deposit array
                        text.Deposit.forEach(function(obj) {
                            deposits += parseFloat(obj.Amount); // Sum deposits
                            accid = obj.AccountProduct; // Store account ID
                        });
                        var Withdraw = 0; // Initialize withdrawals variable
                        // Calculate total withdrawals and account ID from the Withdraw array
                        text.Withdraw.forEach(function(obj) {
                            Withdraw += parseFloat(obj.Amount); // Sum withdrawals
                            accid = obj.AccountProduct; // Store account ID
                        });
                        var shtmla = ''; // Initialize string for product amounts
                        // Append product amounts and descriptions to CSV output
                        text.Products.forEach(function(obj) {
                            shtmla = shtmla + ';' + obj.Amount; // Append amount
                            accid = obj.AccountProduct; // Store account ID
                            shtml += ';' + obj.Description; // Append description
                        });
                        shtml += '\n'; // New line for CSV format
                        // Construct the final sales data row for CSV
                        shtml +=
                            textSp.BetshopId +
                            ';' +
                            textSp.Day +
                            ';' +
                            accid +
                            ';' +
                            tickets +
                            ';' +
                            deposits +
                            ';' +
                            Withdraw +
                            shtmla;
                        var shtml2 = ''; // Initialize string for income CSV output
                        // Set CSV header for income data
                        shtml2 = 'Día;Cuenta Contable;Concepto;Detalle;Monto' + '\n';
                        // Append income details to CSV output
                        text.Incomes.forEach(function(obj) {
                            shtml2 +=
                                textSp.Day +
                                ';' +
                                obj.AccountConcept +
                                ';' +
                                obj.Concept +
                                ';' +
                                obj.Description +
                                ';' +
                                obj.Amount +
                                '\n';
                        });
                        var shtml3 = ''; // Initialize string for expense CSV output
                        // Set CSV header for expense data
                        shtml3 =
                            'Día;Tipo Documento;Serie;Nro Documento;Nro RUC;Proveedor;Cuenta Contable;Descripción;Total' +
                            '\n';
                        // Append expense details to CSV output
                        text.Expenses.forEach(function(obj) {
                            shtml3 +=
                                textSp.Day +
                                ';' +
                                obj.TypeDocument +
                                ';' +
                                obj.Serie +
                                ';' +
                                obj.Reference +
                                ';' +
                                obj.ProviderDocument +
                                ';' +
                                obj.ProviderName +
                                ';' +
                                obj.AccountConcept +
                                ';' +
                                obj.Description +
                                ';' +
                                obj.Amount +
                                '\n';
                        });
                        text.IncomesCreditCards.forEach(function(obj) {
                        }); // Placeholder for credit card income processing
                        // Create a Blob for sales data and trigger download
                        var blob = new Blob([shtml.toString()], {
                            type: 'text/plain',
                        });
                        webix.html.download(blob, 'ventas.csv'); // Download sales CSV
                        // Create a Blob for income data and trigger download
                        var blob = new Blob([shtml2.toString()], {
                            type: 'text/plain',
                        });
                        webix.html.download(blob, 'ingresos.csv'); // Download income CSV
                        // Create a Blob for expense data and trigger download
                        var blob = new Blob([shtml3.toString()], {
                            type: 'text/plain',
                        });
                        webix.html.download(blob, 'compras.csv'); // Download expense CSV
                    },
                },
            );
        });

        // Event listener for updating financial data for a specific customer
        this.on(this.app, 'customer2:updateFinance2', (id) => {
            $$('templateResume').setHTML(''); // Clear the HTML content of the template
            const test = this; // Reference to the current context
            // AJAX request to fetch accounting details for a specific day
            webix.ajax().get(devConfig.geturlApi() + 'Accounting/GetDetailsSquareDay', 'id=' + id + '&FExport=1', {
                error: function(text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Display error message on failure
                },
                success: function(text, data, XmlHttpRequest) {
                    var textSp = JSON.parse(text); // Parse the JSON response
                    text = textSp.Data; // Extract the relevant data from the response
                    var d = new webix.DataCollection(); // Create a new data collection instance
                    // Parse the initial data structure into the data collection
                    d.parse(
                        [
                            [
                                _('Sub Diario'), // Sub Diary
                                _('Número de Comprobante'), // Voucher Number
                                _('Fecha de Comprobante'), // Voucher Date
                                _('Código de Moneda'), // Currency Code
                                _('Glosa Principal'), // Main Gloss
                                _('Tipo de Cambio'), // Exchange Rate
                                _('Tipo de Conversión'), // Conversion Type
                                _('Flag de Conversión de Moneda'), // Currency Conversion Flag
                                _('Fecha Tipo de Cambio'), // Exchange Rate Date
                                _('Cuenta Contable'), // Accounting Account
                                _('Código de Anexo'), // Annex Code
                                _('Código de Centro de Costo'), // Cost Center Code
                                _('Debe / Haber'), // Debit / Credit
                                _('Importe Original'), // Original Amount
                                _('Importe en Dólares'), // Amount in Dollars
                                _('Importe en Soles'), // Amount in Soles
                                _('Tipo de Documento'), // Document Type
                                _('Número de Documento'), // Document Number
                                _('Fecha de Documento'), // Document Date
                                _('Fecha de Vencimiento'), // Expiration Date
                                _('Código de Area'), // Area Code
                                _('Glosa Detalle'), // Detail Gloss
                                _('Código de Anexo Auxiliar'), // Auxiliary Annex Code
                                _('Medio de Pago'), // Payment Method
                                _('Tipo de Documento de Referencia'), // Reference Document Type
                                _('Número de Documento Referencia'), // Reference Document Number
                                _('Fecha Documento Referencia'), // Reference Document Date
                                _('Nro Máq. Registradora Tipo Doc. Ref.'), // Cash Register Number for Reference Doc Type
                                _('Base Imponible Documento Referencia'), // Taxable Base for Reference Document
                                _('IGV Documento Provisión'), // VAT for Provision Document
                                _('Tipo Referencia en estado MQ'), // Reference Type in MQ state
                                _('Número Serie Caja Registradora'), // Cash Register Serial Number
                                _('Fecha de Operación'), // Operation Date
                                _('Tipo de Tasa'), // Rate Type
                                _('Tasa Detracción/Percepción'), // Withholding/Perception Rate
                                _('Importe Base Detracción/Percepción Dólares'), // Base Amount for Withholding/Perception in Dollars
                                _('Importe Base Detracción/Percepción Soles'), // Base Amount for Withholding/Perception in Soles
                                _('Tipo Cambio para F'), // Exchange Rate for F
                                _('Importe de IGV sin derecho crédito fiscal'), // VAT Amount without tax credit right
                            ],
                            [
                                _('Ver T.G. 02'), // See T.G. 02
                                _('Los dos primeros dígitos son el mes y los otros 4 siguientes un correlativo'), // First two digits are the month and the next four are a sequential number
                                _(''), // Empty entry
                                _('Ver T.G. 03'), // See T.G. 03
                                _(''), // Empty entry
                                _('Llenar  solo si Tipo de Conversión es \'C\'. Debe estar entre >=0 y <=9999.999999'), // Fill only if Conversion Type is 'C'. Must be between >=0 and <=9999.999999
                                _('Solo: \'C\'= Especial, \'M\'=Compra, \'V\'=Venta , \'F\' De acuerdo a fecha'), // Only: 'C'= Special, 'M'=Purchase, 'V'=Sale, 'F' According to date
                                _('Solo: \'S\' = Si se convierte, \'N\'= No se convierte'), // Only: 'S' = Yes converted, 'N'= Not converted
                                _('Si  Tipo de Conversión \'F\''), // If Conversion Type is 'F'
                                _('Debe existir en el Plan de Cuentas'), // Must exist in the Chart of Accounts
                                _(
                                    'Si Cuenta Contable tiene seleccionado Tipo de Anexo, debe existir en la tabla de Anexos',
                                ), // If Accounting Account has selected Annex Type, it must exist in the Annexes table
                                _('Si Cuenta Contable tiene habilitado C. Costo, Ver T.G. 05'), // If Accounting Account has enabled Cost Center, See T.G. 05
                                _('\'D\' ó \'H\''), // 'D' or 'H'
                                _(
                                    'Importe original de la cuenta contable. Obligatorio, debe estar entre >=0 y <=99999999999.99 ',
                                ), // Original amount of the accounting account. Mandatory, must be between >=0 and <=99999999999.99
                                _(
                                    'Importe de la Cuenta Contable en Dólares. Obligatorio si Flag de Conversión de Moneda esta en \'N\', debe estar entre >=0 y <=99999999999.99 ',
                                ), // Amount of the Accounting Account in Dollars. Mandatory if Currency Conversion Flag is 'N', must be between >=0 and <=99999999999.99
                                _(
                                    'Importe de la Cuenta Contable en Soles. Obligatorio si Flag de Conversión de Moneda esta en \'N\', debe estra entre >=0 y <=99999999999.99 ',
                                ), // Amount of the Accounting Account in Soles. Mandatory if Currency Conversion Flag is 'N', must be between >=0 and <=99999999999.99
                                _('Si Cuenta Contable tiene habilitado el Documento Referencia Ver T.G. 06'), // If Accounting Account has enabled Reference Document See T.G. 06
                                _('Si Cuenta Contable tiene habilitado el Documento Referencia Incluye Serie y Número'), // If Accounting Account has enabled Reference Document Includes Series and Number
                                _('Si Cuenta Contable tiene habilitado el Documento Referencia'), // If Accounting Account has enabled Reference Document
                                _('Si Cuenta Contable tiene habilitada la Fecha de Vencimiento'), // If Accounting Account has enabled Expiration Date
                                _('Si Cuenta Contable tiene habilitada el Area. Ver T.G. 26'), // If Accounting Account has enabled Area. See T.G. 26
                                _(''), // Empty entry
                                _('Si Cuenta Contable tiene seleccionado Tipo de Anexo Referencia'), // If Accounting Account has selected Reference Annex Type
                                _('Si Cuenta Contable tiene habilitado Tipo Medio Pago. Ver T.G. \'S1\''), // If Accounting Account has enabled Payment Method Type. See T.G. 'S1'
                                _('Si Tipo de Documento es \'NA\' ó \'ND\' Ver T.G. 06'), // If Document Type is 'NA' or 'ND' See T.G. 06
                                _('Si Tipo de Documento es \'NC\', \'NA\' ó \'ND\', incluye Serie y Número'), // If Document Type is 'NC', 'NA' or 'ND', includes Series and Number
                                _('Si Tipo de Documento es \'NC\', \'NA\' ó \'ND\''), // If Document Type is 'NC', 'NA' or 'ND'
                                _(
                                    'Si Tipo de Documento es \'NC\', \'NA\' ó \'ND\'. Solo cuando el Tipo Documento de Referencia \'TK\'',
                                ), // If Document Type is 'NC', 'NA' or 'ND'. Only when Reference Document Type is 'TK'
                                _('Si Tipo de Documento es \'NC\', \'NA\' ó \'ND\''), // If Document Type is 'NC', 'NA' or 'ND'
                                _('Si Tipo de Documento es \'NC\', \'NA\' ó \'ND\''), // If Document Type is 'NC', 'NA' or 'ND'
                                _(
                                    'Si la Cuenta Contable tiene Habilitado Documento Referencia 2 y  Tipo de Documento es \'TK\'',
                                ), // If the Accounting Account has Enabled Reference Document 2 and Document Type is 'TK'
                                _(
                                    'Si la Cuenta Contable teien Habilitado Documento Referencia 2 y  Tipo de Documento es \'TK\'',
                                ), // If the Accounting Account has Enabled Reference Document 2 and Document Type is 'TK'
                                _(
                                    'Si la Cuenta Contable tiene Habilitado Documento Referencia 2. Cuando Tipo de Documento es \'TK\', consignar la fecha de emision del ticket',
                                ), // If the Accounting Account has Enabled Reference Document 2. When Document Type is 'TK', record the ticket issue date
                                _(
                                    'Si la Cuenta Contable tiene configurada la Tasa:  Si es \'1\' ver T.G. 28 y \'2\' ver T.G. 29',
                                ), // If the Accounting Account has configured the Rate: If it is '1' see T.G. 28 and '2' see T.G. 29
                                _(
                                    'Si la Cuenta Contable tiene conf. en Tasa:  Si es \'1\' ver T.G. 28 y \'2\' ver T.G. 29. Debe estar entre >=0 y <=999.99',
                                ), // If the Accounting Account has configured Rate: If it is '1' see T.G. 28 and '2' see T.G. 29. Must be between >=0 and <=999.99
                                _(
                                    'Si la Cuenta Contable tiene configurada la Tasa. Debe ser el importe total del documento y estar entre >=0 y <=99999999999.99',
                                ), // If the Accounting Account has configured Rate. Must be the total amount of the document and be between >=0 and <=99999999999.99
                                _(
                                    'Si la Cuenta Contable tiene configurada la Tasa. Debe ser el importe total del documento y estar entre >=0 y <=99999999999.99',
                                ), // If the Accounting Account has configured Rate. Must be the total amount of the document and be between >=0 and <=99999999999.99
                                _('Especificar solo si Tipo Conversión es \'F\'. Se permite \'M\' Compra y \'V\' Venta.'), // Specify only if Conversion Type is 'F'. 'M' Purchase and 'V' Sale are allowed.
                                _(
                                    'Especificar solo para comprobantes de compras con IGV sin derecho de crédito Fiscal. Se detalle solo en la cuenta 42xxxx',
                                ), // Specify only for purchase vouchers with VAT without tax credit right. Detail only in account 42xxxx
                            ],
                        ],
                        'jsarray', // Specify the data format as JavaScript array
                    );
                    // Process tickets from the response
                    text.Tickets.forEach(function(obj) {
                        console.log('Tickets: ', obj); // Log ticket information
                        if (obj.Amount != '0') { // Check if the amount is not zero
                            var data4, data9; // Variables for account descriptions
                            if (obj.AccountProduct == null) { // Check if AccountProduct is null
                                data4 = obj.AccountConceptDescription; // Use AccountConceptDescription
                                data9 = obj.AccountConcept; // Use AccountConcept
                            } else {
                                data4 = obj.AccountProductDescription; // Use AccountProductDescription
                                data9 = obj.AccountProduct; // Use AccountProduct
                            }
                            // Parse ticket data into the data collection
                            d.parse([
                                {
                                    data0: '07', // Data identifier
                                    data1: '', // Empty entry
                                    data2: obj.Date, // Ticket date
                                    data3: 'MN', // Currency type
                                    data4: data4, // Account description
                                    data5: '', // Empty entry
                                    data6: '', // Empty entry
                                    data7: '', // Empty entry
                                    data8: '', // Empty entry
                                    data9: data9, // Account code
                                    data10: '', // Empty entry
                                    data11: '', // Empty entry
                                    data12: 'H', // Credit indicator
                                    data13: obj.Amount, // Amount
                                    data14: '', // Empty entry
                                    data15: '', // Empty entry
                                    data16: '', // Empty entry
                                    data17:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for internal use
                                    data18:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for display
                                    data19:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Duplicate formatted date for another use
                                    data20: '', // Empty entry
                                    data21: obj.Description, // Ticket description
                                    data22: '', // Empty entry
                                    data23: '', // Empty entry
                                    data24: '', // Empty entry
                                    data25: '', // Empty entry
                                    data26: '', // Empty entry
                                    data27: '', // Empty entry
                                    data28: '', // Empty entry
                                    data29: '', // Empty entry
                                    data30: '', // Empty entry
                                    data31: '', // Empty entry
                                    data32: '', // Empty entry
                                    data33: '', // Empty entry
                                    data34: '', // Empty entry
                                    data35: '', // Empty entry
                                    data36: '', // Empty entry
                                    data37: '', // Empty entry
                                    data38: '', // Empty entry
                                    data39: '', // Empty entry
                                },
                            ]);
                        }
                        if (obj.AmountWin != '0') { // Check if the winning amount is not zero
                            var data4, data9; // Variables for account descriptions
                            if (obj.AccountProduct == null) { // Check if AccountProduct is null
                                data4 = obj.AccountConceptDescription; // Use AccountConceptDescription
                                data9 = obj.AccountConcept; // Use AccountConcept
                            } else {
                                data4 = obj.AccountProductDescription; // Use AccountProductDescription
                                data9 = obj.AccountProduct; // Use AccountProduct
                            }
                            // Parse winning ticket data into the data collection
                            d.parse([
                                {
                                    data0: '07', // Data identifier
                                    data1: '', // Empty entry
                                    data2: obj.Date, // Ticket date
                                    data3: 'MN', // Currency type
                                    data4: data4, // Account description
                                    data5: '', // Empty entry
                                    data6: '', // Empty entry
                                    data7: '', // Empty entry
                                    data8: '', // Empty entry
                                    data9: data9, // Account code
                                    data10: '', // Empty entry
                                    data11: '', // Empty entry
                                    data12: 'D', // Debit indicator
                                    data13: obj.AmountWin, // Winning amount
                                    data14: '', // Empty entry
                                    data15: '', // Empty entry
                                    data16: '', // Empty entry
                                    data17:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for internal use
                                    data18:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for display
                                    data19:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Duplicate formatted date for another use
                                    data20: '', // Empty entry
                                    data21: obj.Description, // Ticket description
                                    data22: '', // Empty entry
                                    data23: '', // Empty entry
                                    data24: '', // Empty entry
                                    data25: '', // Empty entry
                                    data26: '', // Empty entry
                                    data27: '', // Empty entry
                                    data28: '', // Empty entry
                                    data29: '', // Empty entry
                                    data30: '', // Empty entry
                                    data31: '', // Empty entry
                                    data32: '', // Empty entry
                                    data33: '', // Empty entry
                                    data34: '', // Empty entry
                                    data35: '', // Empty entry
                                    data36: '', // Empty entry
                                    data37: '', // Empty entry
                                    data38: '', // Empty entry
                                    data39: '', // Empty entry
                                },
                            ]);
                        }
                    });
                    // Process deposits from the response
                    text.Deposit.forEach(function(obj) {
                        console.log('Deposit: ', obj); // Log deposit information
                        if (obj.Amount != '0') { // Check if the amount is not zero
                            var data4, data9; // Variables for account descriptions
                            if (obj.AccountProduct == null) { // Check if AccountProduct is null
                                data4 = obj.AccountConceptDescription; // Use AccountConceptDescription
                                data9 = obj.AccountConcept; // Use AccountConcept
                            } else {
                                data4 = obj.AccountProductDescription; // Use AccountProductDescription
                                data9 = obj.AccountProduct; // Use AccountProduct
                            }
                            // Parse deposit data into the data collection
                            d.parse([
                                {
                                    data0: '07', // Data identifier
                                    data1: '', // Empty entry
                                    data2: obj.Date, // Deposit date
                                    data3: 'MN', // Currency type
                                    data4: data4, // Account description
                                    data5: '', // Empty entry
                                    data6: '', // Empty entry
                                    data7: '', // Empty entry
                                    data8: '', // Empty entry
                                    data9: data9, // Account code
                                    data10: '', // Empty entry
                                    data11: '', // Empty entry
                                    data12: 'H', // Credit indicator
                                    data13: obj.Amount, // Amount
                                    data14: '', // Empty entry
                                    data15: '', // Empty entry
                                    data16: '', // Empty entry
                                    data17:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for internal use
                                    data18:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for display
                                    data19:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Duplicate formatted date for another use
                                    data20: '', // Empty entry
                                    data21: obj.Description, // Deposit description
                                    data22: '', // Empty entry
                                    data23: '', // Empty entry
                                    data24: '', // Empty entry
                                    data25: '', // Empty entry
                                    data26: '', // Empty entry
                                    data27: '', // Empty entry
                                    data28: '', // Empty entry
                                    data29: '', // Empty entry
                                    data30: '', // Empty entry
                                    data31: '', // Empty entry
                                    data32: '', // Empty entry
                                    data33: '', // Empty entry
                                    data34: '', // Empty entry
                                    data35: '', // Empty entry
                                    data36: '', // Empty entry
                                    data37: '', // Empty entry
                                    data38: '', // Empty entry
                                    data39: '', // Empty entry
                                },
                            ]);
                        }
                    });
                    // Process withdrawals from the response
                    text.Withdraw.forEach(function(obj) {
                        console.log('Withdraw: ', obj); // Log withdrawal information
                        if (obj.Amount != '0') { // Check if the amount is not zero
                            var data4, data9; // Variables for account descriptions
                            if (obj.AccountProduct == null) { // Check if AccountProduct is null
                                data4 = obj.AccountConceptDescription; // Use AccountConceptDescription
                                data9 = obj.AccountConcept; // Use AccountConcept
                            } else {
                                data4 = obj.AccountProductDescription; // Use AccountProductDescription
                                data9 = obj.AccountProduct; // Use AccountProduct
                            }
                            // Parse withdrawal data into the data collection
                            d.parse([
                                {
                                    data0: '07', // Data identifier
                                    data1: '', // Empty entry
                                    data2: obj.Date, // Withdrawal date
                                    data3: 'MN', // Currency type
                                    data4: data4, // Account description
                                    data5: '', // Empty entry
                                    data6: '', // Empty entry
                                    data7: '', // Empty entry
                                    data8: '', // Empty entry
                                    data9: data9, // Account code
                                    data10: '', // Empty entry
                                    data11: '', // Empty entry
                                    data12: 'D', // Debit indicator
                                    data13: obj.Amount, // Amount
                                    data14: '', // Empty entry
                                    data15: '', // Empty entry
                                    data16: '', // Empty entry
                                    data17:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for internal use
                                    data18:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for display
                                    data19:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Duplicate formatted date for another use
                                    data20: '', // Empty entry
                                    data21: obj.Description, // Withdrawal description
                                    data22: '', // Empty entry
                                    data23: '', // Empty entry
                                    data24: '', // Empty entry
                                    data25: '', // Empty entry
                                    data26: '', // Empty entry
                                    data27: '', // Empty entry
                                    data28: '', // Empty entry
                                    data29: '', // Empty entry
                                    data30: '', // Empty entry
                                    data31: '', // Empty entry
                                    data32: '', // Empty entry
                                    data33: '', // Empty entry
                                    data34: '', // Empty entry
                                    data35: '', // Empty entry
                                    data36: '', // Empty entry
                                    data37: '', // Empty entry
                                    data38: '', // Empty entry
                                    data39: '', // Empty entry
                                },
                            ]);
                        }
                    });
                    // Process products from the response
                    text.Products.forEach(function(obj) {
                        console.log('Products: ', obj); // Log product information
                        if (obj.Amount != '0') { // Check if the amount is not zero
                            var data4, data9; // Variables for account descriptions
                            if (obj.AccountProduct == null) { // Check if AccountProduct is null
                                data4 = obj.AccountConceptDescription; // Use AccountConceptDescription
                                data9 = obj.AccountConcept; // Use AccountConcept
                            } else {
                                data4 = obj.AccountProductDescription; // Use AccountProductDescription
                                data9 = obj.AccountProduct; // Use AccountProduct
                            }
                            // Parse product data into the data collection
                            d.parse([
                                {
                                    data0: '07', // Data identifier
                                    data1: '', // Empty entry
                                    data2: obj.Date, // Product date
                                    data3: 'MN', // Currency type
                                    data4: data4, // Account description
                                    data5: '', // Empty entry
                                    data6: '', // Empty entry
                                    data7: '', // Empty entry
                                    data8: '', // Empty entry
                                    data9: data9, // Account code
                                    data10: '', // Empty entry
                                    data11: '', // Empty entry
                                    data12: 'H', // Credit indicator
                                    data13: obj.Amount, // Amount
                                    data14: '', // Empty entry
                                    data15: '', // Empty entry
                                    data16: '', // Empty entry
                                    data17:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for internal use
                                    data18:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for display
                                    data19:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Duplicate formatted date for another use
                                    data20: '', // Empty entry
                                    data21: obj.Description, // Product description
                                    data22: '', // Empty entry
                                    data23: '', // Empty entry
                                    data24: '', // Empty entry
                                    data25: '', // Empty entry
                                    data26: '', // Empty entry
                                    data27: '', // Empty entry
                                    data28: '', // Empty entry
                                    data29: '', // Empty entry
                                    data30: '', // Empty entry
                                    data31: '', // Empty entry
                                    data32: '', // Empty entry
                                    data33: '', // Empty entry
                                    data34: '', // Empty entry
                                    data35: '', // Empty entry
                                    data36: '', // Empty entry
                                    data37: '', // Empty entry
                                    data38: '', // Empty entry
                                    data39: '', // Empty entry
                                },
                            ]);
                        }
                        if (obj.AmountWin != 0) { // Check if the winning amount is not zero
                            var data4, data9; // Variables for account descriptions
                            if (obj.AccountProduct == null) { // Check if AccountProduct is null
                                data4 = obj.AccountConceptDescription; // Use AccountConceptDescription
                                data9 = obj.AccountConcept; // Use AccountConcept
                            } else {
                                data4 = obj.AccountProductDescription; // Use AccountProductDescription
                                data9 = obj.AccountProduct; // Use AccountProduct
                            }
                            // Parse winning product data into the data collection
                            d.parse([
                                {
                                    data0: '07', // Data identifier
                                    data1: '', // Empty entry
                                    data2: obj.Date, // Product date
                                    data3: 'MN', // Currency type
                                    data4: data4, // Account description
                                    data5: '', // Empty entry
                                    data6: '', // Empty entry
                                    data7: '', // Empty entry
                                    data8: '', // Empty entry
                                    data9: data9, // Account code
                                    data10: '', // Empty entry
                                    data11: '', // Empty entry
                                    data12: 'D', // Debit indicator
                                    data13: obj.AmountWin, // Winning amount
                                    data14: '', // Empty entry
                                    data15: '', // Empty entry
                                    data16: '', // Empty entry
                                    data17:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for internal use
                                    data18:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for display
                                    data19:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Duplicate formatted date for another use
                                    data20: '', // Empty entry
                                    data21: obj.Description, // Product description
                                    data22: '', // Empty entry
                                    data23: '', // Empty entry
                                    data24: '', // Empty entry
                                    data25: '', // Empty entry
                                    data26: '', // Empty entry
                                    data27: '', // Empty entry
                                    data28: '', // Empty entry
                                    data29: '', // Empty entry
                                    data30: '', // Empty entry
                                    data31: '', // Empty entry
                                    data32: '', // Empty entry
                                    data33: '', // Empty entry
                                    data34: '', // Empty entry
                                    data35: '', // Empty entry
                                    data36: '', // Empty entry
                                    data37: '', // Empty entry
                                    data38: '', // Empty entry
                                    data39: '', // Empty entry
                                },
                            ]);
                        }
                    });
                    // Process incomes from the response
                    text.Incomes.forEach(function(obj) {
                        console.log('Incomes: ', obj); // Log income information
                        if (obj.Amount != '0') { // Check if the amount is not zero
                            var data4, data9; // Variables for account descriptions
                            if (obj.AccountProduct == null) { // Check if AccountProduct is null
                                data4 = obj.AccountConceptDescription; // Use AccountConceptDescription
                                data9 = obj.AccountConcept; // Use AccountConcept
                            } else {
                                data4 = obj.AccountProductDescription; // Use AccountProductDescription
                                data9 = obj.AccountProduct; // Use AccountProduct
                            }
                            // Parse income data into the data collection
                            d.parse([
                                {
                                    data0: '01', // Data identifier
                                    data1: '', // Empty entry
                                    data2: obj.Date, // Income date
                                    data3: 'MN', // Currency type
                                    data4: data4, // Account description
                                    data5: '', // Empty entry
                                    data6: '', // Empty entry
                                    data7: '', // Empty entry
                                    data8: '', // Empty entry
                                    data9: data9, // Account code
                                    data10: '', // Empty entry
                                    data11: '', // Empty entry
                                    data12: 'H', // Credit indicator
                                    data13: obj.Amount, // Amount
                                    data14: '', // Empty entry
                                    data15: '', // Empty entry
                                    data16: '', // Empty entry
                                    data17: obj.Reference, // Reference for income
                                    data18:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for display
                                    data19:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Duplicate formatted date for another use
                                    data20: '', // Empty entry
                                    data21: obj.Description, // Income description
                                    data22: '', // Empty entry
                                    data23: '', // Empty entry
                                    data24: '', // Empty entry
                                    data25: '', // Empty entry
                                    data26: '', // Empty entry
                                    data27: '', // Empty entry
                                    data28: '', // Empty entry
                                    data29: '', // Empty entry
                                    data30: '', // Empty entry
                                    data31: '', // Empty entry
                                    data32: '', // Empty entry
                                    data33: '', // Empty entry
                                    data34: '', // Empty entry
                                    data35: '', // Empty entry
                                    data36: '', // Empty entry
                                    data37: '', // Empty entry
                                    data38: '', // Empty entry
                                    data39: '', // Empty entry
                                },
                            ]);
                        }
                    });
                    // Process expenses from the response
                    text.Expenses.forEach(function(obj) {
                        console.log('Expenses: ', obj); // Log expense information
                        if (obj.Amount != '0') { // Check if the amount is not zero
                            var data4, data9; // Variables for account descriptions
                            if (obj.AccountProduct == null) { // Check if AccountProduct is null
                                data4 = obj.AccountConceptDescription; // Use AccountConceptDescription
                                data9 = obj.AccountConcept; // Use AccountConcept
                            } else {
                                data4 = obj.AccountProductDescription; // Use AccountProductDescription
                                data9 = obj.AccountProduct; // Use AccountProduct
                            }
                            // Parse expense data into the data collection
                            d.parse([
                                {
                                    data0: '14', // Data identifier
                                    data1: '', // Empty entry
                                    data2: obj.Date, // Expense date
                                    data3: 'MN', // Currency type
                                    data4: data4, // Account description
                                    data5: '', // Empty entry
                                    data6: '', // Empty entry
                                    data7: '', // Empty entry
                                    data8: '', // Empty entry
                                    data9: data9, // Account code
                                    data10: '', // Empty entry
                                    data11: '', // Empty entry
                                    data12: 'D', // Debit indicator
                                    data13: obj.Amount, // Amount
                                    data14: '', // Empty entry
                                    data15: '', // Empty entry
                                    data16: '', // Empty entry
                                    data17: obj.Serie + ' - ' + obj.Reference, // Expense reference
                                    data18:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for display
                                    data19:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Duplicate formatted date for another use
                                    data20: '', // Empty entry
                                    data21: obj.Description, // Expense description
                                    data22: '', // Empty entry
                                    data23: '', // Empty entry
                                    data24: '', // Empty entry
                                    data25: '', // Empty entry
                                    data26: '', // Empty entry
                                    data27: '', // Empty entry
                                    data28: '', // Empty entry
                                    data29: '', // Empty entry
                                    data30: '', // Empty entry
                                    data31: '', // Empty entry
                                    data32: '', // Empty entry
                                    data33: '', // Empty entry
                                    data34: '', // Empty entry
                                    data35: '', // Empty entry
                                    data36: '', // Empty entry
                                    data37: '', // Empty entry
                                    data38: '', // Empty entry
                                    data39: '', // Empty entry
                                },
                            ]);
                        }
                    });
                    // Export the data collection to Excel
                    webix.toExcel(d, {
                        filename:
                            'Virtualsoft - ' +
                            new Date()
                                .toLocaleString('en-GB', {
                                    hour12: true,
                                })
                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1') // Format the date for the filename
                                .replace(/[\/:]/g, '_') // Replace slashes and colons with underscores
                                .toUpperCase() +
                            ' - ' +
                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) + // Check if there are data to include in the filename
                            _('Cuadre de día'), // Day reconciliation
                        header: false, // Do not include header in the export
                    });
                },
            });
        });

        // Event listener for 'customer3:updateFinance2' event
        this.on(this.app, 'customer3:updateFinance2', (filterData) => {
            $$('templateResume').setHTML(''); // Clear the HTML content of the templateResume
            var object = Object.entries(filterData); // Convert filterData object to an array of key-value pairs
            const test = this; // Reference to the current context
            var string1 = ''; // Initialize query string

            // Iterate over each entry in the object
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range from Datepicker
                        var date = object[i][1].split(' - '); // Split date range into start and end dates
                        string1 = string1 + 'dateFrom=' + date[0]; // Append start date to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Append end date to query string
                    } else {
                        // Append other key-value pairs to query string
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    // Handle case where value is an object
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to array
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                // Check for 'start' and 'end' keys in the nested object
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create a Date object from the start value
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() + ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) + ':' +
                                        ('00' + d.getDate()).slice(-2) + ' ' +
                                        ('00' + d.getHours()).slice(-2) + ':' +
                                        ('00' + d.getMinutes()).slice(-2) + ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append formatted start date to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create a Date object from the end value
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() + ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) + ':' +
                                            ('00' + d.getDate()).slice(-2) + ' ' +
                                            ('00' + d.getHours()).slice(-2) + ':' +
                                            ('00' + d.getMinutes()).slice(-2) + ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append formatted end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // Make an AJAX GET request to retrieve accounting details
            webix.ajax().get(devConfig.geturlApi() + 'Accounting/GetDetailsSquareDay', string1, {
                error: function(text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Display error message on failure
                },
                success: function(text, data, XmlHttpRequest) {
                    var textSp = JSON.parse(text); // Parse the response text as JSON
                    text = textSp.Data; // Extract the Data property from the parsed response
                    var d = new webix.DataCollection(); // Create a new DataCollection instance
                    d.parse(
                        [
                            // Define the structure of the data collection
                            [
                                _('Sub Diario'),
                                _('Número de Comprobante'),
                                _('Fecha de Comprobante'),
                                _('Código de Moneda'),
                                _('Glosa Principal'),
                                _('Tipo de Cambio'),
                                _('Tipo de Conversión'),
                                _('Flag de Conversión de Moneda'),
                                _('Fecha Tipo de Cambio'),
                                _('Cuenta Contable'),
                                _('Código de Anexo'),
                                _('Código de Centro de Costo'),
                                _('Debe / Haber'),
                                _('Importe Original'),
                                _('Importe en Dólares'),
                                _('Importe en Soles'),
                                _('Tipo de Documento'),
                                _('Número de Documento'),
                                _('Fecha de Documento'),
                                _('Fecha de Vencimiento'),
                                _('Código de Area'),
                                _('Glosa Detalle'),
                                _('Código de Anexo Auxiliar'),
                                _('Medio de Pago'),
                                _('Tipo de Documento de Referencia'),
                                _('Número de Documento Referencia'),
                                _('Fecha Documento Referencia'),
                                _('Nro Máq. Registradora Tipo Doc. Ref.'),
                                _('Base Imponible Documento Referencia'),
                                _('IGV Documento Provisión'),
                                _('Tipo Referencia en estado MQ'),
                                _('Número Serie Caja Registradora'),
                                _('Fecha de Operación'),
                                _('Tipo de Tasa'),
                                _('Tasa Detracción/Percepción'),
                                _('Importe Base Detracción/Percepción Dólares'),
                                _('Importe Base Detracción/Percepción Soles'),
                                _('Tipo Cambio para F'),
                                _('Importe de IGV sin derecho crédito fiscal'),
                            ],
                            [
                                // Define the corresponding descriptions for each field
                                _('Ver T.G. 02'),
                                _('Los dos primeros dígitos son el mes y los otros 4 siguientes un correlativo'),
                                _(''),
                                _('Ver T.G. 03'),
                                _(''),
                                _('Llenar  solo si Tipo de Conversión es \'C\'. Debe estar entre >=0 y <=9999.999999'),
                                _('Solo: \'C\'= Especial, \'M\'=Compra, \'V\'=Venta , \'F\' De acuerdo a fecha'),
                                _('Solo: \'S\' = Si se convierte, \'N\'= No se convierte'),
                                _('Si  Tipo de Conversión \'F\''),
                                _('Debe existir en el Plan de Cuentas'),
                                _(
                                    'Si Cuenta Contable tiene seleccionado Tipo de Anexo, debe existir en la tabla de Anexos',
                                ),
                                _('Si Cuenta Contable tiene habilitado C. Costo, Ver T.G. 05'),
                                _('\'D\' ó \'H\''),
                                _(
                                    'Importe original de la cuenta contable. Obligatorio, debe estar entre >=0 y <=99999999999.99 ',
                                ),
                                _(
                                    'Importe de la Cuenta Contable en Dólares. Obligatorio si Flag de Conversión de Moneda esta en \'N\', debe estar entre >=0 y <=99999999999.99 ',
                                ),
                                _(
                                    'Importe de la Cuenta Contable en Soles. Obligatorio si Flag de Conversión de Moneda esta en \'N\', debe estra entre >=0 y <=99999999999.99 ',
                                ),
                                _('Si Cuenta Contable tiene habilitado el Documento Referencia Ver T.G. 06'),
                                _('Si Cuenta Contable tiene habilitado el Documento Referencia Incluye Serie y Número'),
                                _('Si Cuenta Contable tiene habilitado el Documento Referencia'),
                                _('Si Cuenta Contable tiene habilitada la Fecha de Vencimiento'),
                                _('Si Cuenta Contable tiene habilitada el Area. Ver T.G. 26'),
                                _(''),
                                _('Si Cuenta Contable tiene seleccionado Tipo de Anexo Referencia'),
                                _('Si Cuenta Contable tiene habilitado Tipo Medio Pago. Ver T.G. \'S1\''),
                                _('Si Tipo de Documento es \'NA\' ó \'ND\' Ver T.G. 06'),
                                _('Si Tipo de Documento es \'NC\', \'NA\' ó \'ND\', incluye Serie y Número'),
                                _('Si Tipo de Documento es \'NC\', \'NA\' ó \'ND\''),
                                _(
                                    'Si Tipo de Documento es \'NC\', \'NA\' ó \'ND\'. Solo cuando el Tipo Documento de Referencia \'TK\'',
                                ),
                                _('Si Tipo de Documento es \'NC\', \'NA\' ó \'ND\''),
                                _('Si Tipo de Documento es \'NC\', \'NA\' ó \'ND\''),
                                _(
                                    'Si la Cuenta Contable tiene Habilitado Documento Referencia 2 y  Tipo de Documento es \'TK\'',
                                ),
                                _(
                                    'Si la Cuenta Contable teien Habilitado Documento Referencia 2 y  Tipo de Documento es \'TK\'',
                                ),
                                _(
                                    'Si la Cuenta Contable tiene Habilitado Documento Referencia 2. Cuando Tipo de Documento es \'TK\', consignar la fecha de emision del ticket',
                                ),
                                _(
                                    'Si la Cuenta Contable tiene configurada la Tasa:  Si es \'1\' ver T.G. 28 y \'2\' ver T.G. 29',
                                ),
                                _(
                                    'Si la Cuenta Contable tiene conf. en Tasa:  Si es \'1\' ver T.G. 28 y \'2\' ver T.G. 29. Debe estar entre >=0 y <=999.99',
                                ),
                                _(
                                    'Si la Cuenta Contable tiene configurada la Tasa. Debe ser el importe total del documento y estar entre >=0 y <=99999999999.99',
                                ),
                                _(
                                    'Si la Cuenta Contable tiene configurada la Tasa. Debe ser el importe total del documento y estar entre >=0 y <=99999999999.99',
                                ),
                                _('Especificar solo si Tipo Conversión es \'F\'. Se permite \'M\' Compra y \'V\' Venta.'),
                                _(
                                    'Especificar solo para comprobantes de compras con IGV sin derecho de crédito Fiscal. Se detalle solo en la cuenta 42xxxx',
                                ),
                            ],
                        ],
                        'jsarray', // Specify the format of the data
                    );

                    // Process Tickets data
                    text.Tickets.forEach(function(obj) {
                        console.log('Tickets: ', obj); // Log each ticket object
                        if (obj.Amount != '0') { // Check if Amount is not zero
                            var data4, data9; // Initialize variables for account descriptions
                            if (obj.AccountProduct == null) {
                                data4 = obj.AccountConceptDescription; // Use AccountConceptDescription if AccountProduct is null
                                data9 = obj.AccountConcept; // Use AccountConcept
                            } else {
                                data4 = obj.AccountProductDescription; // Use AccountProductDescription if AccountProduct exists
                                data9 = obj.AccountProduct; // Use AccountProduct
                            }
                            d.parse([
                                {
                                    data0: '07', // Fixed value for data0
                                    data1: '', // Placeholder for data1
                                    data2: obj.Date, // Date of the ticket
                                    data3: 'MN', // Currency code
                                    data4: data4, // Account description
                                    data5: '', // Placeholder for data5
                                    data6: '', // Placeholder for data6
                                    data7: '', // Placeholder for data7
                                    data8: '', // Placeholder for data8
                                    data9: data9, // Account product
                                    data10: '', // Placeholder for data10
                                    data11: '', // Placeholder for data11
                                    data12: 'H', // Indicator for debit/credit
                                    data13: obj.Amount, // Amount of the ticket
                                    data14: '', // Placeholder for data14
                                    data15: '', // Placeholder for data15
                                    data16: '', // Placeholder for data16
                                    data17:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data17
                                    data18:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data18
                                    data19:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data19
                                    data20: '', // Placeholder for data20
                                    data21: obj.Description, // Description of the ticket
                                    data22: '', // Placeholder for data22
                                    data23: '', // Placeholder for data23
                                    data24: '', // Placeholder for data24
                                    data25: '', // Placeholder for data25
                                    data26: '', // Placeholder for data26
                                    data27: '', // Placeholder for data27
                                    data28: '', // Placeholder for data28
                                    data29: '', // Placeholder for data29
                                    data30: '', // Placeholder for data30
                                    data31: '', // Placeholder for data31
                                    data32: '', // Placeholder for data32
                                    data33: '', // Placeholder for data33
                                    data34: '', // Placeholder for data34
                                    data35: '', // Placeholder for data35
                                    data36: '', // Placeholder for data36
                                    data37: '', // Placeholder for data37
                                    data38: '', // Placeholder for data38
                                    data39: '', // Placeholder for data39
                                },
                            ]);
                        }
                        if (obj.AmountWin != '0') { // Check if AmountWin is not zero
                            var data4, data9; // Initialize variables for account descriptions
                            if (obj.AccountProduct == null) {
                                data4 = obj.AccountConceptDescription; // Use AccountConceptDescription if AccountProduct is null
                                data9 = obj.AccountConcept; // Use AccountConcept
                            } else {
                                data4 = obj.AccountProductDescription; // Use AccountProductDescription if AccountProduct exists
                                data9 = obj.AccountProduct; // Use AccountProduct
                            }
                            d.parse([
                                {
                                    data0: '07', // Fixed value for data0
                                    data1: '', // Placeholder for data1
                                    data2: obj.Date, // Date of the ticket
                                    data3: 'MN', // Currency code
                                    data4: data4, // Account description
                                    data5: '', // Placeholder for data5
                                    data6: '', // Placeholder for data6
                                    data7: '', // Placeholder for data7
                                    data8: '', // Placeholder for data8
                                    data9: data9, // Account product
                                    data10: '', // Placeholder for data10
                                    data11: '', // Placeholder for data11
                                    data12: 'D', // Indicator for debit/credit
                                    data13: obj.AmountWin, // Amount of the winning ticket
                                    data14: '', // Placeholder for data14
                                    data15: '', // Placeholder for data15
                                    data16: '', // Placeholder for data16
                                    data17:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data17
                                    data18:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data18
                                    data19:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data19
                                    data20: '', // Placeholder for data20
                                    data21: obj.Description, // Description of the winning ticket
                                    data22: '', // Placeholder for data22
                                    data23: '', // Placeholder for data23
                                    data24: '', // Placeholder for data24
                                    data25: '', // Placeholder for data25
                                    data26: '', // Placeholder for data26
                                    data27: '', // Placeholder for data27
                                    data28: '', // Placeholder for data28
                                    data29: '', // Placeholder for data29
                                    data30: '', // Placeholder for data30
                                    data31: '', // Placeholder for data31
                                    data32: '', // Placeholder for data32
                                    data33: '', // Placeholder for data33
                                    data34: '', // Placeholder for data34
                                    data35: '', // Placeholder for data35
                                    data36: '', // Placeholder for data36
                                    data37: '', // Placeholder for data37
                                    data38: '', // Placeholder for data38
                                    data39: '', // Placeholder for data39
                                },
                            ]);
                        }
                    });

                    // Process Deposit data
                    text.Deposit.forEach(function(obj) {
                        console.log('Deposit: ', obj); // Log each deposit object
                        if (obj.Amount != '0') { // Check if Amount is not zero
                            var data4, data9; // Initialize variables for account descriptions
                            if (obj.AccountProduct == null) {
                                data4 = obj.AccountConceptDescription; // Use AccountConceptDescription if AccountProduct is null
                                data9 = obj.AccountConcept; // Use AccountConcept
                            } else {
                                data4 = obj.AccountProductDescription; // Use AccountProductDescription if AccountProduct exists
                                data9 = obj.AccountProduct; // Use AccountProduct
                            }
                            d.parse([
                                {
                                    data0: '07', // Fixed value for data0
                                    data1: '', // Placeholder for data1
                                    data2: obj.Date, // Date of the deposit
                                    data3: 'MN', // Currency code
                                    data4: data4, // Account description
                                    data5: '', // Placeholder for data5
                                    data6: '', // Placeholder for data6
                                    data7: '', // Placeholder for data7
                                    data8: '', // Placeholder for data8
                                    data9: data9, // Account product
                                    data10: '', // Placeholder for data10
                                    data11: '', // Placeholder for data11
                                    data12: 'H', // Indicator for debit/credit
                                    data13: obj.Amount, // Amount of the deposit
                                    data14: '', // Placeholder for data14
                                    data15: '', // Placeholder for data15
                                    data16: '', // Placeholder for data16
                                    data17:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data17
                                    data18:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data18
                                    data19:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data19
                                    data20: '', // Placeholder for data20
                                    data21: obj.Description, // Description of the deposit
                                    data22: '', // Placeholder for data22
                                    data23: '', // Placeholder for data23
                                    data24: '', // Placeholder for data24
                                    data25: '', // Placeholder for data25
                                    data26: '', // Placeholder for data26
                                    data27: '', // Placeholder for data27
                                    data28: '', // Placeholder for data28
                                    data29: '', // Placeholder for data29
                                    data30: '', // Placeholder for data30
                                    data31: '', // Placeholder for data31
                                    data32: '', // Placeholder for data32
                                    data33: '', // Placeholder for data33
                                    data34: '', // Placeholder for data34
                                    data35: '', // Placeholder for data35
                                    data36: '', // Placeholder for data36
                                    data37: '', // Placeholder for data37
                                    data38: '', // Placeholder for data38
                                    data39: '', // Placeholder for data39
                                },
                            ]);
                        }
                    });

                    // Process Withdraw data
                    text.Withdraw.forEach(function(obj) {
                        console.log('Withdraw: ', obj); // Log each withdraw object
                        if (obj.Amount != '0') { // Check if Amount is not zero
                            var data4, data9; // Initialize variables for account descriptions
                            if (obj.AccountProduct == null) {
                                data4 = obj.AccountConceptDescription; // Use AccountConceptDescription if AccountProduct is null
                                data9 = obj.AccountConcept; // Use AccountConcept
                            } else {
                                data4 = obj.AccountProductDescription; // Use AccountProductDescription if AccountProduct exists
                                data9 = obj.AccountProduct; // Use AccountProduct
                            }
                            d.parse([
                                {
                                    data0: '07', // Fixed value for data0
                                    data1: '', // Placeholder for data1
                                    data2: obj.Date, // Date of the withdraw
                                    data3: 'MN', // Currency code
                                    data4: data4, // Account description
                                    data5: '', // Placeholder for data5
                                    data6: '', // Placeholder for data6
                                    data7: '', // Placeholder for data7
                                    data8: '', // Placeholder for data8
                                    data9: data9, // Account product
                                    data10: '', // Placeholder for data10
                                    data11: '', // Placeholder for data11
                                    data12: 'D', // Indicator for debit/credit
                                    data13: obj.Amount, // Amount of the withdraw
                                    data14: '', // Placeholder for data14
                                    data15: '', // Placeholder for data15
                                    data16: '', // Placeholder for data16
                                    data17:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data17
                                    data18:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data18
                                    data19:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data19
                                    data20: '', // Placeholder for data20
                                    data21: obj.Description, // Description of the withdraw
                                    data22: '', // Placeholder for data22
                                    data23: '', // Placeholder for data23
                                    data24: '', // Placeholder for data24
                                    data25: '', // Placeholder for data25
                                    data26: '', // Placeholder for data26
                                    data27: '', // Placeholder for data27
                                    data28: '', // Placeholder for data28
                                    data29: '', // Placeholder for data29
                                    data30: '', // Placeholder for data30
                                    data31: '', // Placeholder for data31
                                    data32: '', // Placeholder for data32
                                    data33: '', // Placeholder for data33
                                    data34: '', // Placeholder for data34
                                    data35: '', // Placeholder for data35
                                    data36: '', // Placeholder for data36
                                    data37: '', // Placeholder for data37
                                    data38: '', // Placeholder for data38
                                    data39: '', // Placeholder for data39
                                },
                            ]);
                        }
                    });

                    // Process Products data
                    text.Products.forEach(function(obj) {
                        console.log('Products: ', obj); // Log each product object
                        if (obj.Amount != '0') { // Check if Amount is not zero
                            var data4, data9; // Initialize variables for account descriptions
                            if (obj.AccountProduct == null) {
                                data4 = obj.AccountConceptDescription; // Use AccountConceptDescription if AccountProduct is null
                                data9 = obj.AccountConcept; // Use AccountConcept
                            } else {
                                data4 = obj.AccountProductDescription; // Use AccountProductDescription if AccountProduct exists
                                data9 = obj.AccountProduct; // Use AccountProduct
                            }
                            d.parse([
                                {
                                    data0: '07', // Fixed value for data0
                                    data1: '', // Placeholder for data1
                                    data2: obj.Date, // Date of the product
                                    data3: 'MN', // Currency code
                                    data4: data4, // Account description
                                    data5: '', // Placeholder for data5
                                    data6: '', // Placeholder for data6
                                    data7: '', // Placeholder for data7
                                    data8: '', // Placeholder for data8
                                    data9: data9, // Account product
                                    data10: '', // Placeholder for data10
                                    data11: '', // Placeholder for data11
                                    data12: 'H', // Indicator for debit/credit
                                    data13: obj.Amount, // Amount of the product
                                    data14: '', // Placeholder for data14
                                    data15: '', // Placeholder for data15
                                    data16: '', // Placeholder for data16
                                    data17:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data17
                                    data18:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data18
                                    data19:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data19
                                    data20: '', // Placeholder for data20
                                    data21: obj.Description, // Description of the product
                                    data22: '', // Placeholder for data22
                                    data23: '', // Placeholder for data23
                                    data24: '', // Placeholder for data24
                                    data25: '', // Placeholder for data25
                                    data26: '', // Placeholder for data26
                                    data27: '', // Placeholder for data27
                                    data28: '', // Placeholder for data28
                                    data29: '', // Placeholder for data29
                                    data30: '', // Placeholder for data30
                                    data31: '', // Placeholder for data31
                                    data32: '', // Placeholder for data32
                                    data33: '', // Placeholder for data33
                                    data34: '', // Placeholder for data34
                                    data35: '', // Placeholder for data35
                                    data36: '', // Placeholder for data36
                                    data37: '', // Placeholder for data37
                                    data38: '', // Placeholder for data38
                                    data39: '', // Placeholder for data39
                                },
                            ]);
                        }
                        if (obj.AmountWin != 0) { // Check if AmountWin is not zero
                            var data4, data9; // Initialize variables for account descriptions
                            if (obj.AccountProduct == null) {
                                data4 = obj.AccountConceptDescription; // Use AccountConceptDescription if AccountProduct is null
                                data9 = obj.AccountConcept; // Use AccountConcept
                            } else {
                                data4 = obj.AccountProductDescription; // Use AccountProductDescription if AccountProduct exists
                                data9 = obj.AccountProduct; // Use AccountProduct
                            }
                            d.parse([
                                {
                                    data0: '07', // Fixed value for data0
                                    data1: '', // Placeholder for data1
                                    data2: obj.Date, // Date of the product
                                    data3: 'MN', // Currency code
                                    data4: data4, // Account description
                                    data5: '', // Placeholder for data5
                                    data6: '', // Placeholder for data6
                                    data7: '', // Placeholder for data7
                                    data8: '', // Placeholder for data8
                                    data9: data9, // Account product
                                    data10: '', // Placeholder for data10
                                    data11: '', // Placeholder for data11
                                    data12: 'D', // Indicator for debit/credit
                                    data13: obj.AmountWin, // Amount of the winning product
                                    data14: '', // Placeholder for data14
                                    data15: '', // Placeholder for data15
                                    data16: '', // Placeholder for data16
                                    data17:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data17
                                    data18:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data18
                                    data19:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data19
                                    data20: '', // Placeholder for data20
                                    data21: obj.Description, // Description of the winning product
                                    data22: '', // Placeholder for data22
                                    data23: '', // Placeholder for data23
                                    data24: '', // Placeholder for data24
                                    data25: '', // Placeholder for data25
                                    data26: '', // Placeholder for data26
                                    data27: '', // Placeholder for data27
                                    data28: '', // Placeholder for data28
                                    data29: '', // Placeholder for data29
                                    data30: '', // Placeholder for data30
                                    data31: '', // Placeholder for data31
                                    data32: '', // Placeholder for data32
                                    data33: '', // Placeholder for data33
                                    data34: '', // Placeholder for data34
                                    data35: '', // Placeholder for data35
                                    data36: '', // Placeholder for data36
                                    data37: '', // Placeholder for data37
                                    data38: '', // Placeholder for data38
                                    data39: '', // Placeholder for data39
                                },
                            ]);
                        }
                    });

                    // Process Incomes data
                    text.Incomes.forEach(function(obj) {
                        console.log('Incomes: ', obj); // Log each income object
                        if (obj.Amount != '0') { // Check if Amount is not zero
                            var data4, data9; // Initialize variables for account descriptions
                            if (obj.AccountProduct == null) {
                                data4 = obj.AccountConceptDescription; // Use AccountConceptDescription if AccountProduct is null
                                data9 = obj.AccountConcept; // Use AccountConcept
                            } else {
                                data4 = obj.AccountProductDescription; // Use AccountProductDescription if AccountProduct exists
                                data9 = obj.AccountProduct; // Use AccountProduct
                            }
                            d.parse([
                                {
                                    data0: '01', // Fixed value for data0
                                    data1: '', // Placeholder for data1
                                    data2: obj.Date, // Date of the income
                                    data3: 'MN', // Currency code
                                    data4: data4, // Account description
                                    data5: '', // Placeholder for data5
                                    data6: '', // Placeholder for data6
                                    data7: '', // Placeholder for data7
                                    data8: '', // Placeholder for data8
                                    data9: data9, // Account product
                                    data10: '', // Placeholder for data10
                                    data11: '', // Placeholder for data11
                                    data12: 'H', // Indicator for debit/credit
                                    data13: obj.Amount, // Amount of the income
                                    data14: '', // Placeholder for data14
                                    data15: '', // Placeholder for data15
                                    data16: '', // Placeholder for data16
                                    data17: obj.Reference, // Reference of the income
                                    data18:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data18
                                    data19:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data19
                                    data20: '', // Placeholder for data20
                                    data21: obj.Description, // Description of the income
                                    data22: '', // Placeholder for data22
                                    data23: '', // Placeholder for data23
                                    data24: '', // Placeholder for data24
                                    data25: '', // Placeholder for data25
                                    data26: '', // Placeholder for data26
                                    data27: '', // Placeholder for data27
                                    data28: '', // Placeholder for data28
                                    data29: '', // Placeholder for data29
                                    data30: '', // Placeholder for data30
                                    data31: '', // Placeholder for data31
                                    data32: '', // Placeholder for data32
                                    data33: '', // Placeholder for data33
                                    data34: '', // Placeholder for data34
                                    data35: '', // Placeholder for data35
                                    data36: '', // Placeholder for data36
                                    data37: '', // Placeholder for data37
                                    data38: '', // Placeholder for data38
                                    data39: '', // Placeholder for data39
                                },
                            ]);
                        }
                    });

                    // Process Expenses data
                    text.Expenses.forEach(function(obj) {
                        console.log('Expenses: ', obj); // Log each expense object
                        if (obj.Amount != '0') { // Check if Amount is not zero
                            var data4, data9; // Initialize variables for account descriptions
                            if (obj.AccountProduct == null) {
                                data4 = obj.AccountConceptDescription; // Use AccountConceptDescription if AccountProduct is null
                                data9 = obj.AccountConcept; // Use AccountConcept
                            } else {
                                data4 = obj.AccountProductDescription; // Use AccountProductDescription if AccountProduct exists
                                data9 = obj.AccountProduct; // Use AccountProduct
                            }
                            d.parse([
                                {
                                    data0: '14', // Fixed value for data0
                                    data1: '', // Placeholder for data1
                                    data2: obj.Date, // Date of the expense
                                    data3: 'MN', // Currency code
                                    data4: data4, // Account description
                                    data5: '', // Placeholder for data5
                                    data6: '', // Placeholder for data6
                                    data7: '', // Placeholder for data7
                                    data8: '', // Placeholder for data8
                                    data9: data9, // Account product
                                    data10: '', // Placeholder for data10
                                    data11: '', // Placeholder for data11
                                    data12: 'D', // Indicator for debit/credit
                                    data13: obj.Amount, // Amount of the expense
                                    data14: '', // Placeholder for data14
                                    data15: '', // Placeholder for data15
                                    data16: '', // Placeholder for data16
                                    data17: obj.Serie + ' - ' + obj.Reference, // Reference of the expense
                                    data18:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data18
                                    data19:
                                        obj.Date.charAt(8) +
                                        obj.Date.charAt(9) +
                                        '/' +
                                        obj.Date.charAt(5) +
                                        obj.Date.charAt(6) +
                                        '/' +
                                        obj.Date.charAt(0) +
                                        obj.Date.charAt(1) +
                                        obj.Date.charAt(2) +
                                        obj.Date.charAt(3), // Formatted date for data19
                                    data20: '', // Placeholder for data20
                                    data21: obj.Description, // Description of the expense
                                    data22: '', // Placeholder for data22
                                    data23: '', // Placeholder for data23
                                    data24: '', // Placeholder for data24
                                    data25: '', // Placeholder for data25
                                    data26: '', // Placeholder for data26
                                    data27: '', // Placeholder for data27
                                    data28: '', // Placeholder for data28
                                    data29: '', // Placeholder for data29
                                    data30: '', // Placeholder for data30
                                    data31: '', // Placeholder for data31
                                    data32: '', // Placeholder for data32
                                    data33: '', // Placeholder for data33
                                    data34: '', // Placeholder for data34
                                    data35: '', // Placeholder for data35
                                    data36: '', // Placeholder for data36
                                    data37: '', // Placeholder for data37
                                    data38: '', // Placeholder for data38
                                    data39: '', // Placeholder for data39
                                },
                            ]);
                        }
                    });

                    // Export the data collection to Excel
                    webix.toExcel(d, {
                        filename:
                            'Virtualsoft - ' +
                            new Date()
                                .toLocaleString('en-GB', {
                                    hour12: true,
                                })
                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                .replace(/[\/:]/g, '_')
                                .toUpperCase() +
                            ' - ' +
                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                            _('Cuadre de día'), // Filename for the exported Excel file
                        header: false, // Do not include header in the export
                    });
                },
            });
        });

        /**
         * Converts a Base64 string to a Blob object.
         *
         * @param {string} b64Data - The Base64 encoded string to convert.
         * @param {string} contentType - The MIME type of the resulting Blob.
         * @param {number} sliceSize - The size of each slice to process (default is 512).
         * @returns {Blob} The resulting Blob object.
         */
        function b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || ''; // Default content type if not provided
            sliceSize = sliceSize || 512; // Default slice size if not provided
            var byteCharacters = atob(b64Data); // Decode Base64 string to binary string
            var byteArrays = []; // Array to hold byte arrays
            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize); // Get a slice of the binary string
                var byteNumbers = new Array(slice.length); // Array to hold byte numbers
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i); // Convert each character to its byte number
                }
                var byteArray = new Uint8Array(byteNumbers); // Create a Uint8Array from byte numbers
                byteArrays.push(byteArray); // Add the byte array to the array of byte arrays
            }
            var blob = new Blob(byteArrays, { type: contentType }); // Create a Blob from the byte arrays
            return blob; // Return the resulting Blob
        }

        // Event listener for 'customer4:updateFinance2' event
        this.on(this.app, 'customer4:updateFinance2', (id) => {
            $$('templateResume').setHTML(''); // Clear the HTML content of the templateResume element
            const test = this; // Store the context of 'this'
            webix.ajax().get(
                devConfig.geturlApi() + 'Accounting/GetDetailsSquareDay', // API endpoint to fetch details
                'id=' + id + '&FExport=1&Type=Excel', // Query parameters for the request
                {
                    // Callback functions for the AJAX request
                    error: function(text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Display error message on failure
                    },
                    success: function(text, data, XmlHttpRequest) {
                        var textSp = JSON.parse(text); // Parse the JSON response
                        console.log(textSp); // Log the parsed response for debugging
                        data = textSp.Data; // Extract data from the response
                        var base64data = textSp.base64data; // Extract Base64 data from the response
                        var contentType = textSp.contentType; // Extract content type from the response
                        var name = textSp.name; // Extract file name from the response
                        var blob = b64toBlob(base64data, contentType); // Convert Base64 data to Blob
                        console.log(contentType); // Log the content type for debugging
                        webix.html.download(blob, name); // Trigger download of the Blob with the specified name
                    },
                },
            );
        });
        // Event listener for 'squareDay2:filter' event on the app instance
        this.on(this.app, 'squareDay2:filter', (filterData) => {
            // Convert filterData object into an array of key-value pairs
            var object = Object.entries(filterData);
            console.log(object); // Log the entries for debugging purposes
            var string1 = ''; // Initialize an empty string to build query parameters

            // Iterate through each entry in the object
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle the 'Datepicker' case
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        // Handle other cases except 'Date'
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add key-value pair to query
                        } else {
                            // Handle the 'Date' case specifically
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(
                                    ' 00:00:00',
                                    '', // Remove time from date string
                                );
                                string1 = string1 + '&dateFrom=' + date; // Add date to query
                                string1 = string1 + '&dateTo=' + date; // Add date to query
                            }
                        }
                    }
                } else {
                    // Handle cases where the value is an object
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        // Iterate through each entry in the nested object
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle 'start' date case
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create a Date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() + // Format year
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) + // Format month
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) + // Format day
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) + // Format hours
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) + // Format minutes
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format seconds
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    // Handle 'end' date case
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create a Date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() + // Format year
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) + // Format month
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) + // Format day
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) + // Format hours
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) + // Format minutes
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format seconds
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid before loading new data
            // Load data into the grid with constructed URL and parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1; // Store the constructed filter string
        });
        // Attach an event handler for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function(by, dir, as) {
            // Load the grid data with sorting parameters after sorting is completed
            grid.load(
                url +
                '?start=0&count=' +
                grid.data.$pagesize + // Number of items per page
                filter + // Additional filter parameters
                '&sort[' +
                by + // Sort by the specified field
                ']=' +
                dir, // Sort direction (ascending or descending)
            );
        });

        // Attach an event handler for the 'onItemClick' event of the grid
        grid.attachEvent('onItemClick', function(id, e, node) {
            var item = this.getItem(id); // Retrieve the clicked item using its ID
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger an event with the item's ID
        });

        // Listen for the 'player:select' event from the app
        this.on(this.app, 'player:select', (Id) => {
            // Load the grid data filtered by the selected player's ID
            grid.load(
                url +
                '?start=0&count=' +
                grid.data.$pagesize + // Number of items per page
                '&PlayerId=' +
                Id, // Filter by the selected player's ID
            );
        });
        // Create a popup window for closing a specific day
        var popupAdd = webix.ui({
            view: 'window', // Define the view type as a window
            width: 450, // Set the width of the window
            id: 'closeSpecificDay', // Unique identifier for the window
            head: {
                // Header configuration of the window
                view: 'toolbar', // Define the header as a toolbar
                cols: [
                    // Columns within the toolbar
                    {
                        view: 'toolbar', // Nested toolbar for title
                        css: theme, // Apply CSS theme
                        elements: [
                            // Elements within the nested toolbar
                            {
                                id: 'test', // Unique identifier for the label
                                view: 'label', // Define the element as a label
                                align: 'center', // Center align the label
                                label: _('Cerrar día especifico'), // Label text
                            },
                        ],
                    },
                    {
                        view: 'icon', // Define an icon button
                        icon: 'wxi-close', // Icon type
                        click: function() {
                            // Click event handler
                            this.getTopParentView().hide(); // Hide the window on click
                        },
                    },
                ],
            },
            position: 'center', // Position the window in the center of the screen
            modal: true, // Make the window modal
            body: {
                // Body configuration of the window
                view: 'form', // Define the body as a form
                id: 'addform', // Unique identifier for the form
                elements: [
                    // Form elements
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            // Columns within the form
                            {
                                view: 'datepicker', // Datepicker for selecting a date
                                label: '<span class=\'webix_icon icon-calendar\'></span>' + _('Fecha'), // Label with icon
                                labelPosition: 'top', // Position the label at the top
                                name: 'Date', // Name of the field
                                stringResult: true, // Return date as a string
                                format: '%d  %M %Y', // Date format
                                required: true, // Mark field as required
                            },
                            {
                                view: 'text', // Text input for user ID
                                labelPosition: 'top', // Position the label at the top
                                label: '<span class=\'icon-drivers-license-o\'></span>' + _('ID Usuario'), // Label with icon
                                name: 'UserId', // Name of the field
                                required: true, // Mark field as required
                            },
                        ],
                    },
                    {
                        cols: [
                            // Columns for buttons
                            {
                                view: 'button', // Button for cancel action
                                value: _('Cancelar'), // Button text
                                click: function() {
                                    // Click event handler
                                    this.getTopParentView().hide(); // Hide the window
                                    $$('addform').setValues(
                                        // Reset form values
                                        $$('addform').getCleanValues(),
                                    );
                                },
                            },
                            {
                                view: 'button', // Button for closing the day
                                type: 'form', // Button type as form submit
                                value: _('Cerrar día'), // Button text
                                click: function($e) {
                                    // Click event handler
                                    var values = $$('addform').getValues(); // Get form values
                                    if ($$('addform').validate()) {
                                        // Validate form
                                        var date = values.Date.substr(0, 10); // Extract date
                                        webix // Perform AJAX request
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Accounting/CloseDaySpecific', // API endpoint
                                                '{"DateSpecific":"' + date + '","UserId":"' + values.UserId + '"}', // Request body
                                                {
                                                    error: function(text, data, XmlHttpRequest) {
                                                        // Error callback
                                                        webix.alert({
                                                            type: 'alert-error', // Alert type
                                                            title: 'Error', // Alert title
                                                            text: _('Error! '), // Alert text
                                                        });
                                                    },
                                                    success: function(text, data, XmlHttpRequest) {
                                                        // Success callback
                                                        var resp = JSON.parse(text); // Parse response
                                                        if (!resp.HasError) {
                                                            // Check for errors
                                                            webix.alert({
                                                                type: 'alert-warning', // Alert type
                                                                title: _('Se cerró el día satisfactoriamente'), // Alert title
                                                                text: '', // Alert text
                                                            });
                                                        } else {
                                                            webix.alert({
                                                                type: 'alert-error', // Alert type
                                                                title: 'Error', // Alert title
                                                                text: _('Error! '), // Alert text
                                                            });
                                                        }
                                                    },
                                                },
                                            );
                                        $$('addform').setValues(
                                            // Reset form values
                                            $$('addform').getCleanValues(),
                                        );
                                        this.getTopParentView().hide(); // Hide the window
                                    } else {
                                        webix.message({
                                            // Show error message if validation fails
                                            title: _('¡Error!'), // Message title
                                            type: 'alert-error', // Message type
                                            text: _('Completa los campos...'), // Message text
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
                elementsConfig: {
                    // Configuration for form elements
                    on: {
                        onChange: function() {
                            // Event handler for change
                            this.validate(); // Validate the form on change
                        },
                    },
                },
            },
        });
        // Listen for the 'closeSpecificDay' event on the app instance
        this.on(this.app, 'closeSpecificDay', (filter) => {
            // Clear validation messages on the 'addform' component
            $$('addform').clearValidation();
            // Show the popup for adding a new entry
            popupAdd.show();
        });

        // Listen for the 'export:filter' event on the app instance
        this.on(this.app, 'export:filter', (filterData) => {
            // Flag to indicate if the export process is active
            flag = true;
            var firstfirst;
            // Determine the starting index for data export
            if (filterData.first == 0) {
                firstfirst = filterData.first + 1;
            } else {
                firstfirst = filterData.first;
            }
            // Load data into the grid with specified parameters
            grid.load(url + '?start=' + firstfirst + '&count=' + (filterData.last + 1) + filter);
            // Attach an event handler for after the data is loaded into the datatable
            $$('datatable').attachEvent(
                'onAfterLoad',
                function() {
                    if (flag) {
                        // Get pagination details
                        var size = $$('datatable').getPager().config.size;
                        var page = $$('datatable').getPage();
                        var first = size * page;
                        var last = first + size - 1;
                        // Check if the export type is Excel
                        if ($$('Export').getValue() == '1') {
                            // Remove formatting for columns that have exportType defined
                            for (var j = 0; j < grid.config.columns.length; j++) {
                                if (grid.config.columns[j].exportType) {
                                    delete grid.config.columns[j].format;
                                }
                            }
                            // Trigger the export:data event with report details
                            this.app.callEvent('export:data', [
                                {
                                    NameReport:
                                        _('Reporte de Cuadre de día 2') +
                                        ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                        ' - ' +
                                        new Date().toLocaleString(),
                                    TypeReport: 'Excel',
                                },
                            ]);
                            // Export the grid data to Excel
                            webix.toExcel(grid, {
                                filter: function(obj) {
                                    return (
                                        $$('datatable').getIndexById(obj.id) >= first &&
                                        $$('datatable').getIndexById(obj.id) <= last
                                    );
                                },
                                filename:
                                    'Virtualsoft - ' +
                                    new Date()
                                        .toLocaleString('en-GB', {
                                            hour12: true,
                                        })
                                        .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                        .replace(/[\/:]/g, '_')
                                        .toUpperCase() +
                                    ' - ' +
                                    ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                    _('Reporte de Cuadre de día 2'),
                                ignore: {
                                    ActionTittle: true,
                                    EditCloseBox: true,
                                },
                                footer: false,
                            });
                        } else {
                            // Check if the export type is PDF
                            if ($$('Export').getValue() == '2') {
                                // Trigger the export:data event with report details
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            _('Reporte de Cuadre de día 2') +
                                            ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                            ' - ' +
                                            new Date().toLocaleString(),
                                        TypeReport: 'PDF',
                                    },
                                ]);
                                // Export the datatable data to PDF
                                webix.toPDF($$('datatable'), {
                                    filter: function(obj) {
                                        return (
                                            $$('datatable').getIndexById(obj.id) >= first &&
                                            $$('datatable').getIndexById(obj.id) <= last
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Reporte de Cuadre de día 2'),
                                    autowidth: true,
                                    ignore: {
                                        ActionTittle: true,
                                        EditCloseBox: true,
                                    },
                                    footer: false,
                                });
                            }
                        }
                        // Reset the flag and clear the export selection
                        flag = false;
                        $$('Export').setValue('');
                    }
                }.bind(this), // Bind the context to the current instance
            );
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
